import React from 'react';

export default function ProgressBar({ value = 0, color = 'var(--primary)', label }) {
  const normalized = Math.min(100, Math.max(0, value));
  return <div className="academic-progress-wrap">
    {label && <div className="academic-progress-label"><span>{label}</span><strong>{normalized}%</strong></div>}
    <div className="academic-progress"><span style={{ width: `${normalized}%`, background: color }} /></div>
  </div>;
}
